import { goBack, push } from 'connected-react-router';

export const back = () => dispatch => dispatch(goBack());
export const go = loc => dispatch => dispatch(push(loc));
